import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextareaAutosize from '@material-ui/core/TextareaAutosize'
import StarBorderIcon from '@material-ui/icons/StarBorder'
import { Rating } from '@material-ui/lab'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { X } from 'react-feather'
import { useTranslation } from 'react-i18next'

import { CoreSchema } from '../../../../../../clientFiles/validations'
import {
  BadIcon,
  GoodIcon,
  HappyIcon,
  OkayIcon,
  TerribleIcon,
} from '../../../../../assets/Svg/Index'
import { isNullOrEmpty, noop } from '../../../../../helpers/utils'
import CustomDialog from '../../../../common/CustomDialog'
import LoaderButton from '../../../../common/LoaderButton'

/**
 * Defines a component Review Post
 * @param props
 * @returns {*}
 * @constructor
 */

const initialState = {
  rating: null,
  review: '',
}

function ProgramReviewPost({ open, onClose, rateReviewProgram, programReviewSettings }) {
  const { t } = useTranslation()

  const onSubmit = (values) => {
    rateReviewProgram(values)
  }
  return (
    <CustomDialog
      paper
      className="custom-dialog"
      close={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogTitle disableTypography id="customized-dialog-title" onClose={onClose}>
        <Box pt={1} display="flex" alignItems="center" justifyContent="space-between">
          <Typography tabIndex={0} variant="h5">
            <Box component="span" fontWeight="fontWeightBold">
              {t('reviewProgram')}
            </Box>
          </Typography>
          {onClose ? (
            <IconButton tabIndex={-1} aria-label="close" className="close-button" onClick={onClose}>
              <X />
            </IconButton>
          ) : null}
        </Box>
      </DialogTitle>
      <Box display={'flex'} justifyContent={'center'}>
        <Typography component={'span'} variant="body1" color="textPrimary">
          <Box fontSize={'16px'} fontWeight={500}>
            {t('ratingAndBriefEvaluation')}
          </Box>
        </Typography>
      </Box>

      <Formik
        initialValues={initialState}
        onSubmit={onSubmit}
        validationSchema={
          programReviewSettings[0]?.context_data?.make_review_mandatory &&
          programReviewSettings[0]?.context_data?.enable_review
            ? CoreSchema.reviewMandatory
            : CoreSchema.review
        }
      >
        {({ values, setFieldValue }) => {
          return (
            <Form>
              <DialogContent>
                <DialogContent>
                  <Box>
                    {programReviewSettings[0]?.context_data?.enable_ratings && (
                      <>
                        <Box display={'flex'} justifyContent={'center'}>
                          <FormControl className="rating-emoji-icons" component="fieldset">
                            <RadioGroup row value={values.rating}>
                              <FormControlLabel
                                className={
                                  values.rating === 1 ? 'rating-label-sected ' : 'rating-label'
                                }
                                value={1}
                                control={
                                  <Radio
                                    icon={<TerribleIcon />}
                                    checkedIcon={<TerribleIcon color="primary" />}
                                  />
                                }
                                label={t('terrible')}
                              />
                              <FormControlLabel
                                className={
                                  values.rating === 2 ? 'rating-label-sected' : 'rating-label'
                                }
                                value={2}
                                control={
                                  <Radio
                                    icon={<BadIcon />}
                                    checkedIcon={<BadIcon color="primary" />}
                                  />
                                }
                                label={t('bad')}
                              />
                              <FormControlLabel
                                className={
                                  values.rating === 3 ? 'rating-label-sected' : 'rating-label'
                                }
                                value={3}
                                control={
                                  <Radio
                                    icon={<OkayIcon />}
                                    checkedIcon={<OkayIcon color="primary" />}
                                  />
                                }
                                label={t('okay')}
                              />
                              <FormControlLabel
                                className={
                                  values.rating === 4 ? 'rating-label-sected' : 'rating-label'
                                }
                                value={4}
                                control={
                                  <Radio
                                    icon={<GoodIcon />}
                                    checkedIcon={<GoodIcon color="primary" />}
                                  />
                                }
                                label={t('good')}
                              />
                              <FormControlLabel
                                className={
                                  values.rating === 5 ? 'rating-label-sected' : 'rating-label'
                                }
                                value={5}
                                control={
                                  <Radio
                                    icon={<HappyIcon />}
                                    checkedIcon={<HappyIcon color="primary" />}
                                  />
                                }
                                label={t('happy')}
                              />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                        <Box
                          width="100%"
                          display="flex"
                          alignItems="center"
                          justifyContent={'center'}
                          mt={1}
                        >
                          <Field
                            name="rating"
                            component={() => (
                              <Rating
                                className="rating-start-icon"
                                size="large"
                                value={values.rating}
                                onChange={(event, newValue) => {
                                  setFieldValue('rating', newValue)
                                }}
                                emptyIcon={<StarBorderIcon />}
                              />
                            )}
                          />
                        </Box>
                      </>
                    )}
                    {programReviewSettings[0]?.context_data?.enable_review && (
                      <Box
                        width="100%"
                        mt={3}
                        display="flex"
                        alignItems="flex-start"
                        flexDirection="column"
                      >
                        <Box width="100%" className="description-textarea">
                          <FormControl fullWidth>
                            <TextareaAutosize
                              aria-label="review"
                              minRows={2}
                              placeholder={t('reviewRemarks')}
                              style={{ width: '100%' }}
                              name="review"
                              inputProps={{
                                maxLength: 200,
                              }}
                              value={values?.review || ''}
                              onChange={(e) => setFieldValue('review', e.target.value)}
                            />
                            <ErrorMessage name="review">
                              {(msg) => (
                                <span className="error">
                                  {t(msg, { field: t('fields:review') })}
                                </span>
                              )}
                            </ErrorMessage>
                          </FormControl>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </DialogContent>
              </DialogContent>
              <DialogActions>
                <Button
                  className="custom-default-button text-transform-none"
                  onClick={onClose}
                  size="large"
                  variant="contained"
                  disableElevation
                >
                  {t('cancel')}
                </Button>
                <LoaderButton
                  className="text-transform-none"
                  size="large"
                  variant="contained"
                  disableElevation
                  color="primary"
                  type="submit"
                  disabled={
                    isNullOrEmpty(values.rating) &&
                    programReviewSettings[0]?.context_data?.enable_ratings
                  }
                >
                  {t('submit')}
                </LoaderButton>
              </DialogActions>
            </Form>
          )
        }}
      </Formik>
    </CustomDialog>
  )
}

ProgramReviewPost.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  rateReviewProgram: PropTypes.func,
  programReviewSettings: PropTypes.array,
}
ProgramReviewPost.defaultProps = {
  open: false,
  onClose: noop,
  rateReviewProgram: noop,
  programReviewSettings: [],
}
/**
 /**
 * Review Post modal component
 */
export default ProgramReviewPost
